import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import axios from 'axios';
import Skeleton from 'react-loading-skeleton';

function ShopifyBuyButton({product, storefront_token, plan_id}) {
  const [website_match, affiliate_id] = useSelector((state)=>
      [state.settings.website_match, state.settings.affiliate_id]
  );
  const [url, setURL] = useState(null)
  const [loading, setLoading] = useState(false)
  useEffect(()=>{
    if(product && storefront_token && website_match && affiliate_id, plan_id){
      setLoading(true)
      const items = [
        { variantId: `gid://shopify/ProductVariant/${product.value}`, quantity:1 }
      ]
        axios.post(`https://${website_match}/api/2022-07/graphql.json`,{
            query:`mutation checkoutCreate($input: CheckoutCreateInput!) {
              checkoutCreate(input: $input) {
                checkout {
                  id
                  webUrl
                  note
                }
                checkoutUserErrors {
                  code
                  field
                  message
                }
              }
        }`,
          variables: { input: { note:'Goaffpro memberships', lineItems: items, customAttributes: [
                {
                  key:'Membership Affiliate ID',
                  value:String(affiliate_id)
                },
                {
                  key:'Membership Plan ID',
                  value:String(plan_id),
                }
              ]}
          }
        }, {
          headers:{
            'X-Shopify-Storefront-Access-Token': storefront_token
          }
        }).then(({data})=>{
          console.log(data, data.data, data.data.checkoutCreate)
          setURL(data.data.checkoutCreate.checkout.webUrl)
          setLoading(false)
        })
    }
  },[product, affiliate_id, plan_id, storefront_token, website_match])
  if(product && storefront_token && website_match) {
    if(loading){
      return<div className={"py-2"}><Skeleton width={90} height={36.5} /></div>
    }
    return (
        <div className={"py-2"}>
          <a href={url} className={"btn btn-primary"} title={product.label} target={"_blank"}>Buy Now</a>
        </div>
    );
  }
  return null;
}

export default ShopifyBuyButton;
